<template>
  <div class="list-base">
    <div class="search-card" style="width: 100%">
      <InputSearch
          :value="searchText"
          @input="onSearch"
      />
    </div>
    <div>
      <div
          v-for="(listItem, listItemIndex) in filteredList"
          :key="listItemIndex"
          class="list-base__item"
          @click="onClickListItem(listItem)"
      >
        <div
            :class="{'list-base__item_active': listItemActive !== null && listItemActive.id === listItem.id}"
        >{{ listItem.name || "" }}
        </div>
        <div v-if="listItemActive !== null && listItemActive.childs === listItem.childs">
          <div
              v-for="(subListItem, subListItemIndex) in listItem.childs"
              :key="subListItemIndex"
              class="list-group-select__sublist"
          >
            <i
                v-if="isIconPrev"
                :class="`${iconPrevClass}`"
                :style="{'color': `#a7b0bd`}"
                @click.stop="onClickDeleteCatalog(subListItem)"
            >
            </i>
            {{ subListItem }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InputSearch from "../../components/Base/InputSearch";

export default {
  name: 'ListBaseWithSearch',
  components: {InputSearch},
  /**
   * входные данные компонента
   * @property {array} listItems - элементы списка
   * @property {object} listItemActive - активный элемент списка
   * @property {boolean} isCheckbox - условие отображение чекбоксов
   * @property {boolean} isIconPrev - условие отображения иконки
   * @property {string} iconPrevClass - класс для иконки
   */
  props: {
    listItems: {
      type: Array,
      default: () => ([])
    },
    listItemActive: {
      type: Object,
      default: () => (null)
    },
    checked: {
      type: Array,
      default: () => ([])
    },
    isCheckbox: {
      type: Boolean,
      default: false
    },
    isIconPrev: {
      type: Boolean,
      default: false
    },
    iconPrevClass: {
      type: String,
      default: ''
    }
  },
  /**
   * Данные компонента
   * @property {array} checkedValues - выбранные значения
   */
  data: () => ({
    checkedValues: [],
    searchText: ''
  }),
  computed: {
    filteredList() {
      if (this.searchText) {
        return this.listItems.filter((item) => {
          const {name} = item
          return name.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1
        });
      } else {
        return this.listItems
      }
    }
  },
  watch: {
    /**
     * следим за переключением отображения чекбоксов
     */
    isCheckbox: function (value) {
      if (value === false) {
        this.checkedValues = [];
        this.$emit('onChangeCheckbox', this.checkedValues);
      }
    },
    checked: function (values) {
      this.checkedValues = values;
    }
  },
  methods: {
    onSearch(value) {
      this.searchText = value;
    },
    /**
     * событие клика по элементу списка
     * @param {object} listItem - элемент списка
     */
    onClickListItem(listItem) {
      this.$emit('onClickListItem', listItem);
    },
    /**
     * событие клика по элементу списка
     * @param {object} subListItem - элемент списка
     */
    onClickDeleteCatalog(subListItem) {
      this.$emit('onClickDeleteCatalog', subListItem);
    },
    /**
     * событие изменения чекбокса
     */
    onChangeCheckbox() {
      this.$emit('onChangeCheckbox', this.checkedValues);
    },
    /**
     * событие клика по иконке элемента списка
     * @param {object} listItem - элемент списка
     */
    onClickIconPrev(listItem) {
      this.$emit('onClickIconPrev', listItem);
    }
  }
}
</script>

<style lang="scss" scoped>
.list-base__item {
  padding: 5px 0 5px 15px;
  cursor: pointer;
}

.list-base__item_active {
  background: #f0f0f0;
  border-radius: 30px;
}

.list-group-select__group {
  display: flex;
  justify-content: space-between;
  padding: 5px 0 5px 15px;
  cursor: pointer;
}

.list-group-select__sublist {
  margin: 0 0 0 15px;
  padding: 5px 0 5px 15px;
  cursor: pointer;
}

.list-group-select__group_active {
  background: #f0f0f0;
  border-radius: 30px;
}
</style>